import * as yup from "yup";
import { REGEX } from "../constants/regex";
import moment from "moment";

export const AUTH_PHONE_SCHEMA = yup.object().shape({
  mobile: yup
    .string()
    .required("Mobile number is required")
    .matches(REGEX.MOBILE_NUMBER, "Mobile number should be valid"),
  countryCode: yup.string().required("Country code is required"),
});

export const AUTH_PHONE_OTP_SCHEMA = yup.object().shape({
  otp: yup
    .string()
    .length(4, "OTP must be exactly 4 digits")
    .required("OTP is required"),
});

export const ONBOARDING_PERSONAL_INFO_SCHEMA = yup.object().shape({
  first_name: yup
    .string()
    .required("First name is required")
    .matches(/^[a-zA-Z-' ]+$/)
    .min(1, "First name must be at least 1 character long")
    .max(30, "First name must be at most 30 characters long"),
  last_name: yup
    .string()
    .required("Last name is required")
    .matches(/^[a-zA-Z-' ]+$/)
    .min(1, "Last name must be at least 1 character long")
    .max(30, "Last name must be at most 30 characters long"),
  username: yup
    .string()
    .required("Username is required")
    .matches(/^[a-zA-Z0-9-_]+$/)
    .min(3, "Username must be at least 3 characters long")
    .max(40, "Username must be at most 40 characters long"),
  gender: yup.string().required("Gender is required"),
  dob: yup
    .string() // Validate as string
    .required("Date of Birth is required")
    .test("dob", "Date of Birth cannot be in the future", (value) => {
      return new Date(value) <= new Date();
    })
    .test("dob", "Oops! Check your birth date.", (value) => {
      const dob = moment(value);
      const fourYearsAgo = moment().subtract(4, "years");
      return dob.isBefore(fourYearsAgo);
    }),
});

export const EDIT_PROFILE_SCHEMA = yup.object().shape({
  first_name: yup
    .string()
    .required("First name is required")
    .matches(/^[a-zA-Z-' ]+$/)
    .min(1, "First name must be at least 1 character long")
    .max(30, "First name must be at most 30 characters long"),
  last_name: yup
    .string()
    .required("Last name is required")
    .matches(/^[a-zA-Z-' ]+$/)
    .min(1, "Last name must be at least 1 character long")
    .max(30, "Last name must be at most 30 characters long"),
  // username: yup
  //   .string()
  //   .required("Username is required")
  //   .matches(/^[a-zA-Z0-9-_]+$/)
  //   .min(3, "Username must be at least 3 characters long")
  //   .max(40, "Username must be at most 40 characters"),
  email: yup.string().email("Invalid email").required("Email is required"),
  banner: yup.string(),
  gender: yup.string(),
  dob: yup
    .string() // Validate as string
    .required("Date of Birth is required")
    .test("dob", "Date of Birth cannot be in the future", (value) => {
      return new Date(value) <= new Date();
    })
    .test("dob", "Oops! Check your birth date.", (value) => {
      const dob = moment(value);
      const fourYearsAgo = moment().subtract(4, "years");
      return dob.isBefore(fourYearsAgo);
    }),
  company_name: yup
    .string()
    .max(50, "Company name must be at most 50 characters long"),
  description: yup
    .string()
    .max(150, "Description must be at most 200 characters long"),
  linkedin: yup.string().url("Invalid URL"),
  instagram: yup.string().url("Invalid URL"),
  x: yup.string().url("Invalid URL"),
});

export const ONBOARDING_BUSINESS_DETAILS = yup.object().shape({
  industry: yup
    .string()
    .required("Industry name is required")
    .max(100, "Industry name must be at most 100 characters long"),
  company_name: yup
    .string()
    .required("Company name is required")
    .max(50, "Company name must be at most 50 characters long"),
  designation: yup
    .string()
    .required("Designation is required")
    .max(50, "Designation must be at most 50 characters long"),
  income_range: yup
    .string()
    .required("Annual Income is required")
    .max(100, "Annual Income must be at most 100 characters long"),
});

export const ONBOARDING_EARN_XP_SCHEMA = yup.object().shape({
  linkedin: yup
    .string()
    .test(
      "is-valid-linkedin-url",
      "Must be a valid LinkedIn URL",
      (value) => !value || REGEX.LINKEDIN_PROFILE.test(value),
    ),
  // You can add other fields and their validations here
});
